import { useEffect, useState } from 'react'

/**
 * Custom hook to detect if any modal is currently open in the document.
 * This is useful for disabling drag and drop interactions when modals are active.
 *
 * @returns {boolean} isModalOpen - True if any modal is detected as open
 */
export function useModalDetection(): boolean {
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    const checkForModal = () => {
      const modal =
        document.querySelector('[data-headlessui-state="open"]') ||
        document.querySelector('.helix-modal') ||
        document.querySelector('[role="dialog"]') ||
        document.querySelector('.modal') ||
        document.querySelector('[aria-modal="true"]')

      setIsModalOpen(!!modal)
    }

    checkForModal()

    const observer = new MutationObserver(checkForModal)
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-headlessui-state', 'class', 'aria-modal']
    })

    return () => observer.disconnect()
  }, [])

  return isModalOpen
}
